export const PROJECTS_PATH = "/tasks/projects";

/** Выбранный проект на экране «Проекты» */
export const PROJECT_SEARCH_PARAM = "project";

/** Выбранная задача внутри проекта */
export const TASK_SEARCH_PARAM = "task";

export function projectUrl(projectId: string) {
  const params = new URLSearchParams({ [PROJECT_SEARCH_PARAM]: projectId });

  return `${PROJECTS_PATH}?${params.toString()}`;
}
